<template>
  <v-app :style="{ '--sidebar-width': sidebarCollapsed ? '64px' : '300px' }">
    <sidebar-menu
      class="br_sidebar_menu"
      :menu="$store.getters.sidebar_menu"
      :collapsed="sidebarCollapsed"
      :hide-toggle="!$vuetify.breakpoint.smAndDown"
      theme="white-theme"
      width="300px"
      width-collapsed="64px"
      @toggle-collapse="sidebarCollapsed = $event"
    >
      <template v-slot:header>
        <div class="br_logo">
          <img
            :src="logo"
            :width="sidebarCollapsed ? 44 : 68"
            :height="sidebarCollapsed ? 44 : 68"
            alt="BisonRouter"
          />
        </div>
      </template>
      <template v-slot:toggle-icon>
        <v-icon aria-label="Toggle navigation">mdi-menu</v-icon>
      </template>
      <template v-slot:dropdown-icon>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </sidebar-menu>

    <v-main id="br_main">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import logo from "./assets/bison_router_logo.svg";

export default {
  components: { SidebarMenu },

  data: () => ({
    logo,
    sidebarCollapsed: false
  }),

  watch: {
    "$vuetify.breakpoint.smAndDown": {
      immediate: true,
      handler(smallScreen) {
        this.sidebarCollapsed = smallScreen;
      }
    }
  }
};
</script>

<style>
/* Match the router GUI: a fixed sidebar and pages filling the remaining width. */
#br_main {
  display: block;
  min-width: 0;
  min-height: 100vh;
  padding: 0 15px 15px calc(var(--sidebar-width) + 15px) !important;
  transition: padding-left 0.3s ease;
}

#br_main > .v-main__wrap {
  min-width: 0;
  width: 100%;
}

.br_logo {
  padding-left: 10px;
  padding-bottom: 20px;
}

.br_logo img {
  display: block;
}

.br_sidebar_menu .v-icon {
  color: inherit;
}

.br {
  color: rgb(109, 103, 164);
}

#br_main .v-data-table.elevation-1 tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.03);
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
</style>
